import { createSlice } from "@reduxjs/toolkit";
import { getCategoryItemsMap, sortCategories, transformDataIntoMap, convertArrayToObject, createItemExtrasMap, getSubcatMap } from "../../helpers/catalog-helper";
import { cloneDeep } from "lodash";
import { CATALOG_DATA_REDUCER_KEYS } from "../../data/constants";
import { userNormalLogout, supportLogout } from "../actions";
export interface CatalogState {
  isFetchingCatalogData: boolean;
  isFetchingMenuItem: boolean;
  isApiCallOngoing: boolean;
  menuItemsList: any;
  categoryToItemMap: {};
  menuItemsMap: any; //it will be a map for items {item_id: item_data}
  allCatalogDataList: {};
  allCatalogDataMap: any; // it will have map for all the data,
  allGalleryImagesList: {};
  allGalleryImagesMap: {};
  allItemTags: {};
  uiAtrributes: [];
  itemExtrasMap: {}; //it will have all the info extra fields info of an item
  optionsSetsMap: { results: any, lastKey: any };
  allCategoriesList: any;
  allCategoriesMap: any;
  menuItemWithName: Record<string, any>;
}

const initialState: CatalogState = {
  isFetchingMenuItem: false,
  isFetchingCatalogData: false,
  isApiCallOngoing: false,
  menuItemsList: [],
  categoryToItemMap: {},
  menuItemsMap: {},
  allCatalogDataList: {},
  allCatalogDataMap: {},
  allGalleryImagesList: [],
  allGalleryImagesMap: {},
  allItemTags: {},
  uiAtrributes: [],
  itemExtrasMap: {},
  optionsSetsMap: {
    results: {},
    lastKey: ""
  },
  allCategoriesList: [],
  allCategoriesMap: {},
  menuItemWithName: {},
}

export const catalogSlice = createSlice({
  name: 'business',
  initialState,
  reducers: {
    getAllMenuItems: (state) => {
      state.isFetchingMenuItem = true;
    },
    saveAllMenuItems: (state, actions) => {
      const { catItemMap, menuItemsMap, menuItemWithName } = getCategoryItemsMap(actions.payload)
      state.menuItemsList = actions.payload;
      state.categoryToItemMap = catItemMap;
      state.menuItemWithName = menuItemWithName;
      state.menuItemsMap = menuItemsMap;
      state.isFetchingMenuItem = false;
    },
    getAllItemTags: (state) => { },
    setCategoryItemMap: (state, actions) => {
      state.categoryToItemMap = actions.payload;
    },
    setMenuItemsMap: (state, actions) => {
      state.menuItemsMap = actions.payload;
    },
    deleteMenuItem: (state, actions) => { },
    getAllDataOfCatalog: (state) => {
      state.isFetchingCatalogData = true;
    },
    saveAllCatalogData: (state, actions) => {
      state.isFetchingCatalogData = false;
      const sortedCatList = sortCategories(actions.payload.categories);
      const { subcategories, subcategoriesWithName } = getSubcatMap(sortedCatList); //update subcategory map
      state.allCatalogDataList = { ...actions.payload };
      state.allCatalogDataMap = {
        ...transformDataIntoMap(cloneDeep(actions.payload)),
        categories: convertArrayToObject(sortedCatList),
        categoriesWithName: convertArrayToObject(sortedCatList, 'name', false),
        subcategories,
        subcategoriesWithName,
      };
    },
    saveAllItemTags: (state, actions) => {
      state.allItemTags = convertArrayToObject(actions.payload);
    },
    getGalleryImages: (state, actions) => { },
    saveGalleryImages: (state, actions) => {
      state.allCatalogDataList = actions.payload;
      state.allGalleryImagesMap = convertArrayToObject(actions.payload);
    },
    updateAllCatalogData: (state, actions) => { // it will update both catalog data list and catalog item map
      const catalogDataList: any = cloneDeep(state.allCatalogDataList), catalogDataMap: any = cloneDeep(state.allCatalogDataMap);
      catalogDataList[actions.payload.keyToUpdate][actions.payload.itemIndex] = actions.payload.dataToUpdate;
      catalogDataMap[actions.payload.keyToUpdate][actions.payload.elementId] = actions.payload.dataToUpdate;
      state.allCatalogDataList = catalogDataList;
      state.allCatalogDataMap = catalogDataMap;
    },
    getUiAttributes: (state) => { },
    saveUiAttributes: (state, actions) => {
      state.uiAtrributes = actions.payload;
      state.itemExtrasMap = createItemExtrasMap(actions.payload.item.itemExtras.fields)
    },
    getOptionsSets: (state, actions) => { },
    saveOptionsSet: (state, actions) => {
      const optionsVariantMap = convertArrayToObject(actions.payload.results);
      state.optionsSetsMap = { results: { ...state.optionsSetsMap.results, ...optionsVariantMap }, lastKey: actions.payload.lastKey || "" };
    },
    updateItemData: (state, actions) => { },
    getSingleItemData: (state, actions) => { },
    setSingleItemData: (state, actions) => {
      state.menuItemsMap[actions.payload.mid] = actions.payload;
    },
    saveCategoryData: (state, actions) => { },
    deleteCategoryData: (state, actions) => { },
    updateCategoryData: (state, actions) => {
      const categoriesMap = cloneDeep(state.allCategoriesMap);
      const catalogDataList: any = cloneDeep(state.allCatalogDataList), catalogDataMap: any = cloneDeep(state.allCatalogDataMap);
      if (actions.payload.type === "DELETE")
        delete categoriesMap[actions.payload.data.mid];
      else
        categoriesMap[actions.payload.data.mid] = actions.payload.data;
      const allCatList = sortCategories(Object.values(categoriesMap));

      state.allCategoriesMap = categoriesMap;
      state.allCategoriesList = allCatList;

      catalogDataList[CATALOG_DATA_REDUCER_KEYS.categories] = allCatList;
      catalogDataMap[CATALOG_DATA_REDUCER_KEYS.categories] = categoriesMap;
      const { subcategories, subcategoriesWithName } = getSubcatMap(allCatList); //update subcategory map
      state.allCatalogDataList = catalogDataList;
      state.allCatalogDataMap = {
        ...catalogDataMap,
        subcategories,
        subcategoriesWithName
      };
    },
    getAllCategories: (state) => { },
    saveAllCategories: (state, actions) => {
      state.allCategoriesList = sortCategories(actions.payload);
      state.allCategoriesMap = convertArrayToObject(actions.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const {
  getAllMenuItems,
  saveAllMenuItems,
  getAllItemTags,
  setCategoryItemMap,
  setMenuItemsMap,
  deleteMenuItem,
  getAllDataOfCatalog,
  saveAllCatalogData,
  saveAllItemTags,
  getGalleryImages,
  saveGalleryImages,
  updateAllCatalogData,
  getUiAttributes,
  saveUiAttributes,
  getOptionsSets,
  saveOptionsSet,
  updateItemData,
  getSingleItemData,
  setSingleItemData,
  saveCategoryData,
  updateCategoryData,
  deleteCategoryData,
  getAllCategories,
  saveAllCategories
} = catalogSlice.actions;
export default catalogSlice.reducer;